import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Toast } from '~shared/models/Toast'
import { getToastsToDisplay } from '~store/global/selectors'
import { toastDisplayed } from '~store/global/actions'
import { useAddToast } from '~utils/useAddToast'

const DisplayReduxToasts: React.FC = () => {
  const toastsToDisplay = useSelector(getToastsToDisplay)
  const addToast = useAddToast()
  const dispatch = useDispatch()

  useEffect(() => {
    for (const toastKey in toastsToDisplay) {
      const toast: Toast = toastsToDisplay[toastKey]

      addToast(toast, toastKey)

      dispatch(toastDisplayed({ toastKey }))
    }
  }, [toastsToDisplay, dispatch, addToast])

  return null
}

export default DisplayReduxToasts
